<template>
  <v-dialog v-model="open" max-width="500px">
    <v-card>
      <v-card-title>
        <span>{{ title }}</span>
        <v-spacer></v-spacer>
        <v-icon class="c-close" @click="closeDialog">close</v-icon>
      </v-card-title>
      <v-container grid-list-lg text-xs-left>
        <v-layout column wrap>
          <v-flex class="c-msg">{{ msg }}</v-flex>
          <!-- issue#30: 招待QRにタグを付ける（QRの上）。確定すると tag-token の子 code に差し替わり QR が再描画される -->
          <v-flex v-if="!isGuest" class="c-tag">
            <!-- 入力中: 入力欄＋OK -->
            <div v-if="tagEditing" class="c-tag-input">
              <v-text-field
                v-model="tag"
                ref="tagField"
                :placeholder="$T('page.member.invite.tag.placeholder')"
                maxlength="20"
                counter="20"
                color="clr-primary"
                single-line
                hide-details
                class="c-tag-field"
                @keyup.enter="applyTag"
              ></v-text-field>
              <v-btn
                color="clr-btn"
                flat
                small
                :loading="tagLoading"
                :disabled="tagLoading"
                @click.stop.prevent="applyTag"
                >{{ $T('button.ok') }}</v-btn
              >
            </div>

            <!-- 折りたたみ: タグチップ／付与チップ（同形状・グレーアウトライン）＋右に説明? -->
            <div v-else class="c-tag-row">
              <v-chip
                v-if="currentTag"
                small
                color="clr-primary"
                text-color="white"
                class="c-tag-chip c-hand"
                @click.native="startEditTag"
              >
                <v-icon left small>mdi-tag</v-icon>{{ currentTag }}
              </v-chip>
              <v-chip
                v-else
                small
                outline
                color="grey"
                class="c-tag-add-chip c-hand"
                @click.native="startEditTag"
              >
                <v-icon left small>mdi-tag-outline</v-icon>{{ $T('page.member.invite.tag.add') }}
              </v-chip>
            </div>

            <div v-if="tagEditing" class="c-tag-msg">{{ $T('page.member.invite.tag.msg') }}</div>
            <div v-if="tagError" class="c-tag-err">{{ tagError }}</div>
          </v-flex>
          <v-flex>
            <div class="c-qr">
              <qrcode :value="getInvitationLink(code, userLang)" :options="{ size: 192 }"></qrcode>
            </div>
          </v-flex>
          <v-flex class="c-link">
            <a
              :href="getInvitationLink(code, userLang)"
              class="custom-tooltip"
              v-clipboard:copy="getInvitationLink(code, userLang)"
              v-clipboard:success="onCopy"
              @click.stop.prevent=""
            >
              {{ getInvitationLink(code) }}
              <span class="tooltiptext">{{ $T('community_invitation.click_to_copy') }}</span>
            </a>
          </v-flex>
          <v-flex class="c-expire">
            {{ $T('expire_date') }} : <strong>{{ unixToMin(expired) }}</strong>
          </v-flex>
        </v-layout>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="clr-secondary"
          flat
          :href="'/print/invite/' + printInviteId"
          target="commin-print"
          @click.stop.prevent="openPrintPage(printInviteId)"
          ><v-icon left>mdi-printer</v-icon>{{ $T('page.member.invite.created.qr.button') }}</v-btn
        >
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { createTagToken } from '../../api/communityMember'

export default {
  data() {
    return {
      title: null,
      msg: null,
      open: false,
      id: null,
      code: null,
      expired: null,
      // issue#30: タグ付きQR
      cid: null,
      parentInviteId: null,
      originalCode: null,
      taggedInviteId: null,
      tag: '',
      currentTag: '',
      tagError: '',
      tagLoading: false,
      tagEditing: false,
    }
  },
  watch: {},
  computed: {
    // 印刷対象の invite id。タグ付与済みなら子トークンの id（QRにタグが引き継がれる）
    printInviteId() {
      return this.taggedInviteId || this.id
    },
  },
  methods: {
    openDialog(id, code, expired, createNew, cid, currentTag, originalCode, taggedInviteId) {
      this.title = createNew
        ? $T('page.member.invite.created.qr.title')
        : $T('page.member.invite.view.qr.title')
      this.msg = createNew
        ? $T('page.member.invite.created.qr.msg')
        : $T('page.member.invite.view.qr.msg')
      this.id = id
      this.code = code
      this.expired = expired
      // issue#30: タグ発行に必要な親 invite / community を保持し、状態をリセット
      this.cid = cid
      this.parentInviteId = id
      // 未タグ（親）の code。タグを外したときに QR をこれへ戻す。一覧から既存タグを引き継ぐ
      this.originalCode = originalCode || code
      this.taggedInviteId = taggedInviteId || null
      this.tag = ''
      this.currentTag = currentTag || ''
      this.tagError = ''
      this.tagLoading = false
      this.tagEditing = false
      this.open = true
    },
    // タグ入力欄を開く（初期ボタン／チップのクリックから）。既存タグは引き継いで編集
    startEditTag() {
      this.tag = this.currentTag || ''
      this.tagError = ''
      this.tagEditing = true
      var self = this
      this.$nextTick(function () {
        if (self.$refs.tagField && self.$refs.tagField.focus) self.$refs.tagField.focus()
      })
    },
    applyTag() {
      var t = (this.tag || '').trim()
      this.tagError = ''
      if (!t) {
        // 未入力で OK = タグなしに戻す。QR を未タグの親 code に戻し、初期ボタン表示へ畳む
        this.currentTag = ''
        this.code = this.originalCode
        this.taggedInviteId = null
        this.tag = ''
        this.tagEditing = false
        this.emitTagChange()
        return
      }
      if (t.length > 20) {
        this.tagError = $T('page.member.invite.tag.too_long')
        return
      }
      var self = this
      this.tagLoading = true
      var data = new FormData()
      data.append('cid', this.cid)
      data.append('parent_invite_id', this.parentInviteId)
      data.append('tag', t)
      createTagToken(data)
        .then(function (res) {
          self.tagLoading = false
          // 子トークンの code に差し替え → :value の getInvitationLink(code) が反応的に再描画される
          self.code = res.code
          self.currentTag = t
          self.taggedInviteId = res.id
          self.tag = ''
          // 入力欄を畳んでチップ表示に戻す（再編集はチップクリック）
          self.tagEditing = false
          self.emitTagChange()
        })
        .catch(function (error) {
          self.tagLoading = false
          // 長さ超過(>20)は呼び出し前に弾き済み。ここに来るのは API 失敗（権限なし=403 等）→ 誤って「タグが長すぎ」と出さず汎用の失敗表示にする
          self.tagError = $T('common.failed.register')
          console.error('failed to create tag token', error)
        })
    },
    // 一覧（親）へタグ状態を反映するため通知
    emitTagChange() {
      this.$emit('tagchange', {
        id: this.id,
        code: this.code,
        currentTag: this.currentTag,
        originalCode: this.originalCode,
        taggedInviteId: this.taggedInviteId,
      })
    },
    closeDialog() {
      this.open = false
    },
    onCopy(e) {
      this.shortMsg($T('common.copy.link.succeed'))
    },
    openPrintPage(id) {
      window.open('/print/invite/' + id, 'commin-printer').focus()
      return false
    },
  },
}
</script>

<style scoped>
.container {
  padding: 0px 24px 12px 24px;
}
.c-qr {
  width: 192px;
  margin: 0 auto;
}
.c-link {
  text-align: center;
  font-size: 16px;
  padding-top: 0px !important;
  padding-bottom: 8px !important;
}
.c-link a {
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.c-expire {
  text-align: center;
  padding-top: 0px !important;
  font-size: 13px;
}
.c-expire strong {
  font-size: 18px;
}
.c-tag {
  padding-bottom: 4px !important;
  margin-bottom: 4px;
}
.c-tag-row {
  display: flex;
  align-items: center;
}
.c-tag-help {
  margin-left: 6px;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.38) !important;
  font-size: 18px !important;
}
.c-tag-msg {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
  margin: 4px 0 2px 0;
}
/* 付与チップ = タグチップと同形状のグレー・アウトライン */
.c-tag-add-chip {
  color: rgba(0, 0, 0, 0.55) !important;
}
.c-tag-add-chip .v-icon {
  color: rgba(0, 0, 0, 0.45) !important;
}
.c-tag-chip.c-hand,
.c-tag-add-chip.c-hand {
  cursor: pointer;
}
.c-tag-input {
  display: flex;
  align-items: center;
  margin-top: 2px;
}
.c-tag-field {
  margin-top: 0;
  padding-top: 0;
}
.c-tag-err {
  color: #e64a19;
  font-size: 12px;
  margin-top: 4px;
}
</style>
